import PendoMultiselect from '../../../components/multiselect/pendo-multiselect.vue.js';
import PendoChartTrigger from '../../../components/multiselect/trigger-types/pendo-chart-trigger.vue.js';
import PendoTable from '../../../components/table/pendo-table.vue.js';
import PendoIconButton from '../../../components/icon-button/pendo-icon-button.vue.js';
import PendoGuideProgressCell from '../../../components/table/cell-types/pendo-guide-progress-cell.vue.js';
import PendoStatusOverlay from '../../status-overlay/pendo-status-overlay.vue.js';
import PendoResourceColumnChooser from '../../resource-column-chooser/pendo-resource-column-chooser.vue.js';
import PendoAppDisplay from '../../app-display/pendo-app-display.vue.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';

var script = {
  name: 'PendoGuideActivityTable',
  components: {
    PendoChartTrigger,
    PendoGuideProgressCell,
    PendoIconButton,
    PendoMultiselect,
    PendoTable,
    PendoStatusOverlay,
    PendoResourceColumnChooser,
    PendoAppDisplay
  },
  directives: {
    PendoTooltip
  },
  props: {
    sortConfig: {
      type: Object,
      default: () => ({
        prop: 'visitorId',
        order: 'none'
      })
    },
    columns: {
      type: Array,
      required: true
    },
    activityData: {
      type: Array,
      required: true
    },
    guideActivityAggStatus: {
      type: String,
      required: true
    },
    loadingOptions: {
      type: Object,
      default: () => {}
    },
    selectedActivityType: {
      type: Object,
      default: () => ({
        id: 'byVisitor',
        label: 'By Visitor'
      })
    },
    selectedActivityFilter: {
      type: Object,
      default: () => ({
        id: 'everyone',
        label: 'Everyone'
      })
    },
    showActivityFilter: {
      type: Boolean,
      default: false
    },
    featuresList: {
      type: Array,
      default: () => []
    },
    guidesList: {
      type: Array,
      default: () => []
    },
    pagesList: {
      type: Array,
      default: () => []
    },
    savingColumnChooser: {
      type: Boolean,
      default: false
    },
    isLoadingResources: {
      type: Boolean,
      default: false
    },
    isLoadingMetadata: {
      type: Boolean,
      default: false
    },
    metadataList: {
      type: Array,
      default: () => []
    },
    showCsvDownloadButton: {
      type: Boolean,
      default: false
    },
    showTableHeader: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 600
    },
    borderless: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showManageColumnsModal: false,
      activityTypeOptions: [{
        id: 'byVisitor',
        label: 'By Visitor'
      }, {
        id: 'byEvent',
        label: 'All Events'
      }],
      activityFilterOptions: [{
        id: 'everyone',
        label: 'Everyone'
      }, {
        id: 'seen',
        label: 'Has Seen Guide'
      }, {
        id: 'notSeen',
        label: 'Has Not Seen Guide'
      }],
      overflowTooltipContent: null
    };
  },
  watch: {
    savingColumnChooser(newVal, oldVal) {
      if (!newVal && oldVal && this.showManageColumnsModal) {
        this.showManageColumnsModal = false;
      }
    }
  },
  methods: {
    onSortChange(_ref) {
      let {
        prop,
        order
      } = _ref;
      this.$emit('sortChange', {
        prop,
        order
      });
    },
    onActivityTypeSelect(type) {
      this.$emit('activityTypeSelect', type);
    },
    onActivityFilterSelect(filter) {
      this.$emit('activityFilterSelect', filter);
    },
    downloadCsv() {
      this.$emit('downloadCsv');
    },
    manageColumns() {
      this.$emit('manageColumns');
      this.showManageColumnsModal = true;
    },
    fetchResources(id) {
      this.$emit('fetchResources', id);
    },
    onConfirmColumnsChange(formattedColumnsForTable) {
      this.$emit('confirmColumnsChange', formattedColumnsForTable);
    },
    checkForOverflowingContent(event, row) {
      this.overflowTooltipContent = null;
      const {
        scrollWidth,
        clientWidth
      } = event.target;
      if (scrollWidth > clientWidth) {
        const tooltipText = this.getStepSeentext(row);
        this.overflowTooltipContent = tooltipText;
      }
    },
    getStepSeenText(row) {
      let stepSeentext = `Step ${row.stepIndex}`;
      if (row.appName) {
        stepSeentext += ' - ';
      }
      return stepSeentext;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-activity-table.vue2.js.map
